import React from "react";
import {
 apiCallPost,
 formatAge,
 isPediatricPatient,
 niceDateTime,
 startLowerString,
} from "../util/util";
import {
 Button,
 ControlGroup,
 NonIdealState,
 Spinner,
} from "@blueprintjs/core";
import "../RxV2.css";
import "../RxV21.css";

import ClinicalVisitParametersPreview from "./RxV2Comp/ClinicalVisitParametersPreview";
import _ from "lodash";
import QRCode from "react-qr-code";
import { useParams } from "react-router-dom";
import { generateMasterVisitEntities } from "./RxV2Comp/masterVisitEntities";
import ExaminationDetails from "./RxV21Cmp/ExaminationDetails";
import PlanSection from "./RxV21Cmp/PlanSection";
import HistorySection from "./RxV21Cmp/HistorySection";
import FilesSection from "./RxV21Cmp/FilesSection";
import {
 historySectionDefaultStyle,
 planSectionDefaultStyle,
 filesSectionDefaultStyle,
 examinationSectionDefaultStyle,
} from "./RxV21Cmp/ViewHelper";

function withRouter(Component) {
 function ComponentWithRouter(props) {
  let params = useParams();
  return <Component {...props} params={params} />;
 }
 return ComponentWithRouter;
}

class RxV21_Dispatch extends React.Component {
 state = {
  isLoading: true,
  isError: false,
 };
 componentDidMount() {
  this.getData();
 }
 getData = async () => {
  try {
   let res = await apiCallPost("/print/clinical2", {
    visitId: this.props.params.visitId,
   });
   const renderOptions = res.branchInfo.rxRenderOptions;
   let sectionMaps = _.assign(
    {
     VISION: "Baseline Evaluation",
     HISTORY: "Context of Visit",
     EXAMINATION: "Examination",
     PLAN: "Plan",
     FILES: "Investigations & Procedures",
    },
    {}
   );
   let subSectionMaps = {};
   console.log({ shortcode: res.branchInfo.shortcode });
   const masterVisitEntities = generateMasterVisitEntities(
    res.branchInfo.shortcode || ""
   );
   for (let i = 0; i < masterVisitEntities.length; i++) {
    let section = masterVisitEntities[i];
    subSectionMaps[section.sectionName] = {};
    if (section.subsections) {
     for (let j = 0; j < section.subsections.length; j++) {
      let subSection = section.subsections[j];
      subSectionMaps[section.sectionName][subSection.subsectionName] =
       subSection.subsectionNiceName;
     }
    }
   }
   if (renderOptions.showGlassRxFooter) {
    renderOptions["footerHeight"] = "220px";
   }

   let entities = res.entities;
   if ((renderOptions.suppressOPDRxSection || []).length > 0) {
    const supressSet = new Set(renderOptions.suppressOPDRxSection);
    entities = entities.filter((e) => {
     const key = `${e.sectionName}!${e.subsectionName}`;
     if (supressSet.has(key)) {
      return false;
     }
     return true;
    });
   }

   this.setState({
    ...res,
    entities,
    isLoading: false,
    renderOptions,
    sectionMaps,
    subSectionMaps,
    masterVisitEntities,
   });
  } catch (err) {
   this.setState({
    isError: true,
    isLoading: false,
   });
   console.log(err);
  }
 };
 renderSectionTitle = (text) => {
  return (
   <div
    style={{
     textTransform: "uppercase",
     borderLeft: "2px solid grey",
     letterSpacing: "1mm",
     paddingLeft: "5px",
     backgroundColor: "#E6E7E7",
     width: "fit-content",
     fontSize: "small",
     marginBottom: "10px",
    }}
   >
    <b>{this.state.sectionMaps[text]}</b>
   </div>
  );
 };
 renderSubsectionTitle = (text) => {
  return (
   <div
    style={{
     textTransform: "uppercase",
     borderLeft: "1px solid grey",
     letterSpacing: "1mm",
     paddingLeft: "5px",
     borderBottom: "1px solid grey",
     width: "fit-content",
     fontSize: "small",
     marginBottom: "10px",
     marginTop: "5px",
    }}
   >
    {text}
   </div>
  );
 };
 transformObservations = (data) => {
  if (!data.length) {
   return {
    RIGHT: [],
    LEFT: [],
    OTHER: [],
   };
  }
  let transformedData = {};
  data = data.map((each) => {
   let name = each.entityName;
   if (each.notes) {
    name += ` (${each.notes})`;
   }
   return {
    ...each,
    entityName: name,
   };
  });
  data.forEach((item) => {
   if (!transformedData[item.anatomicalPart]) {
    transformedData[item.anatomicalPart] = {
     RIGHT: [],
     LEFT: [],
     OTHER: [],
    };
   }

   if (item.laterality === "RIGHT" || item.laterality === "BILATERAL") {
    transformedData[item.anatomicalPart].RIGHT.push(item);
   }

   if (item.laterality === "LEFT" || item.laterality === "BILATERAL") {
    transformedData[item.anatomicalPart].LEFT.push(item);
   }

   if (
    item.laterality !== "RIGHT" &&
    item.laterality !== "LEFT" &&
    item.laterality !== "BILATERAL"
   ) {
    transformedData[item.anatomicalPart].OTHER.push(item);
   }
  });
  let sortOrder = [
   "EYE_GENERAL",
   "ORBIT",
   "EXTRA_OCULAR_MUSCLES",
   "LIDS_AND_ADNEXA",
   "CONJUNCTIVA",
   "SCLERA",
   "CORNEA",
   "ANTERIOR_CHAMBER",
   "LENS",
   "IRIS",
   "PUPIL",
   "CHOROID",
   "CILIARY_BODY",
   "DISC",
   "UVEA",
   "VITREOUS",
   "RETINA",
  ];

  // each key of transformedData is an anatomical part
  // sort the ibject by the order above

  let sortedKeys = Object.keys(transformedData).sort((a, b) => {
   let aIndex = sortOrder.indexOf(a);
   let bIndex = sortOrder.indexOf(b);
   return aIndex - bIndex;
  });

  let sortedTransformedData = {};
  sortedKeys.forEach((key) => {
   sortedTransformedData[key] = transformedData[key];
  });

  return sortedTransformedData;
 };
 hasOtherData = (data) => {
  return Object.values(data).some((item) => item.OTHER.length > 0);
 };
 getOrderedSectionNames = () => {
  let sectionsInThisRx = _.uniq(_.map(this.state.entities, "sectionName"));
  sectionsInThisRx.sort((a, b) => {
   let aIndex = _.findIndex(
    this.state.masterVisitEntities,
    (x) => x.sectionName === a
   );
   let bIndex = _.findIndex(
    this.state.masterVisitEntities,
    (x) => x.sectionName === b
   );
   return aIndex - bIndex;
  });

  if (sectionsInThisRx.includes("PLAN")) {
   let planIndex = sectionsInThisRx.indexOf("PLAN");
   sectionsInThisRx.splice(planIndex, 0, "FILES");
  } else if (sectionsInThisRx.includes("EXAMINATION")) {
   let historyIndex = sectionsInThisRx.indexOf("EXAMINATION");
   sectionsInThisRx.splice(historyIndex + 1, 0, "FILES");
  } else if (sectionsInThisRx.includes("HISTORY")) {
   let historyIndex = sectionsInThisRx.indexOf("HISTORY");
   sectionsInThisRx.splice(historyIndex + 1, 0, "FILES");
  } else {
   sectionsInThisRx.push("FILES");
  }
  return sectionsInThisRx;
 };
 renderObservationsTable = (whichEntities) => {
  let transformedData = this.transformObservations(whichEntities);
  let showOtherColumn = this.hasOtherData(transformedData);
  if (!whichEntities.length) {
   return null;
  }
  return (
   <table
    className="bp4-html-table bp4-compact bp4-html-table-bordered bp4-html-table-striped colfax table_vertical_align_center"
    style={{ width: "100%" }}
   >
    <thead>
     <tr>
      <th
       style={{
        padding: "7px",
        fontSize: "smaller",
        width: `${showOtherColumn ? "7%" : "10%"}`,
       }}
      ></th>
      <th
       style={{
        padding: "7px",
        fontSize: "smaller",
        width: `${showOtherColumn ? "45%" : "31%"}`,
       }}
      >
       Right Eye
      </th>
      <th
       style={{
        padding: "7px",
        fontSize: "smaller",
        width: `${showOtherColumn ? "45%" : "31%"}`,
       }}
      >
       Left Eye
      </th>
      {showOtherColumn && (
       <th
        style={{
         padding: "7px",
         fontSize: "smaller",
         width: "31%",
        }}
       ></th>
      )}
     </tr>
    </thead>
    <tbody>
     {Object.keys(transformedData).map((anatomicalPart) => (
      <tr key={anatomicalPart}>
       <td style={{ padding: "7px", fontSize: "smaller" }}>
        {anatomicalPart === "undefined" ? "" : startLowerString(anatomicalPart)}
       </td>
       <td
        style={{
         padding: "7px",
         fontSize: "smaller",
        }}
       >
        {transformedData[anatomicalPart].RIGHT.map(
         (entity) => entity.entityName
        ).join(",")}
       </td>
       <td
        style={{
         padding: "7px",
         fontSize: "smaller",
        }}
       >
        {transformedData[anatomicalPart].LEFT.map(
         (entity) => entity.entityName
        ).join(",")}
       </td>
       {showOtherColumn && (
        <td
         style={{
          padding: "7px",
          fontSize: "smaller",
         }}
        >
         {transformedData[anatomicalPart].OTHER.map(
          (entity) => entity.entityName
         ).join(",")}
        </td>
       )}
      </tr>
     ))}
    </tbody>
   </table>
  );
 };
 renderMainContent = () => {
  let sectionsInThisRx = this.getOrderedSectionNames();
  return sectionsInThisRx.map((section) => {
   if (section === "FILES") {
    return (
     <FilesSection
      sectionName={this.state.sectionMaps[section]}
      fileEntities={this.state.investigationFiles}
      styleOptions={filesSectionDefaultStyle}
     />
    );
   } else if (section === "EXAMINATION") {
    return (
     <ExaminationDetails
      entities={this.state.entities}
      sectionMaps={this.state.sectionMaps}
      subSectionMaps={this.state.subSectionMaps}
      styleOptions={examinationSectionDefaultStyle}
      renderObservationsTable={this.renderObservationsTable}
      renderOptions={this.state.renderOptions}
     />
    );
   } else if (section === "HISTORY") {
    return (
     <HistorySection
      showSubSectionTitle={true}
      entities={this.state.entities}
      sectionMaps={this.state.sectionMaps}
      subSectionMaps={this.state.subSectionMaps}
      styleOptions={historySectionDefaultStyle}
     />
    );
   } else if (section === "PLAN") {
    return (
     <PlanSection
      entities={this.state.entities}
      sectionMaps={this.state.sectionMaps}
      subSectionMaps={this.state.subSectionMaps}
      styleOptions={planSectionDefaultStyle}
      isPediatricPatient={
       isPediatricPatient(this.state.patientInfo.dob) &&
       this.state?.visitInfo?.branch === "Palta"
      }
     />
    );
   }
   return null;
  });
 };
 renderVisitSummaryTopBar = () => {
  return (
   <div
    style={{
     display: "flex",
     justifyContent: "space-between",
     alignItems: "center",
     height: "100%",
     flexWrap: "wrap",
     borderBottom: "1px solid grey",
    }}
   >
    <div style={{ display: "flex", justifyContent: "flex-start" }}>
     <div
      style={{
       letterSpacing: "1mm",
       borderRight: "2px solid #000",
       fontSize: "medium",
       textAlign: "right",
       paddingLeft: "5px",
       paddingRight: "10px",
       display: "flex",
       alignItems: "center",
      }}
     >
      VISIT <br /> SUMMARY
     </div>
     <div
      style={{
       fontSize: "smaller",
      }}
     >
      <div
       style={{
        paddingLeft: "10px",
        textTransform: "uppercase",
       }}
      >
       <b>{this.state.patientInfo.name}</b>
      </div>
      <div
       style={{
        paddingLeft: "10px",
       }}
      >
       {this.state.patientInfo.sex} | {formatAge(this.state.patientInfo.dob)}
      </div>
      <div
       style={{
        paddingLeft: "10px",
       }}
      >
       Reason for Visit: {this.state.visitInfo.purpose}
      </div>
      <div
       style={{
        marginLeft: "10px",
        paddingLeft: "2px",
        paddingRight: "2px",
        border: "1px solid black",
        width: "fit-content",
        fontSize: "large",
        backgroundColor: "#E6E7E7",
       }}
      >
       <b>{this.state.patientInfo.sysPid}</b>
      </div>
     </div>
    </div>
    <div
     style={{
      display: "flex",
      justifyContent: "flex-end",
      fontSize: "smaller",
      flexDirection: "column",
      textAlign: "right",
     }}
    >
     <div>{this.state.patientInfo.address}</div>
     {this.state.isDisha ? null : (
      <div>Phone: {this.state.patientInfo.phone}</div>
     )}
     <div>
      Rx Generated At:{" "}
      <b>
       {this.state.visitInfo.doneAt
        ? niceDateTime(this.state.visitInfo.doneAt)
        : niceDateTime(new Date())}
      </b>
     </div>
     <div className="pres-no__print">
      <ControlGroup>
       <Button
        icon="print"
        text="Print"
        onClick={() => {
         window.print();
        }}
        fill
       />
       {this.state.renderOptions.doBkpPrint ? (
        <Button
         icon="print"
         text="Print (BKP Address)"
         onClick={() => {
          this.setState(
           {
            branchInfo: {
             ...this.state.branchInfo,
             sesiNABH: "/NABH_Logo_1.png",
             hospital_contact: [
              "DISHA EYE HOSPITALS PRIVATE LIMITED",
              "88(63A) GHOSHPARA ROAD",
              "Barrackpore, Kolkata - 7000120",
              "",
             ],
            },
           },
           () => window.print()
          );
         }}
         fill
        />
       ) : null}
      </ControlGroup>
     </div>
    </div>
   </div>
  );
 };
 renderBottomHospitalInfoBarNew = () => {
  return [
   <div
    style={{
     display: "flex",
     justifyContent: "center",
     fontSize: "medium",
     marginBottom: "5px",
     borderBottom: "1px solid grey",
    }}
   >
    <b>
     {this.state.branchInfo?.shortcode === "RECC"
      ? "www.renueye.care"
      : this.state.branchInfo.hospital_contact[0]}
    </b>
   </div>,

   <div
    style={{
     display: "flex",
     flexDirection: "row",
     justifyContent: "space-between",
    }}
   >
    <div
     style={{
      display: "flex",
      flexDirection: "row",
      justifyContent: "start",
     }}
    >
     <div>
      <img
       alt="Client Logo"
       src={this.state.branchInfo.logoUrl}
       height="80px"
       width="auto"
      />
     </div>
     <div
      style={{
       marginLeft: "10px",
       marginRight: "10px",
       textTransform: "uppercase",
       letterSpacing: "1mm",
       fontSize: "small",
       textAlign: "left",
       maxWidth: "125px",
      }}
     >
      {this.state.branchInfo?.shortcode === "RECC" ? (
       <img
        src="/NABHEL.png"
        alt="NABH Entry Level Certified"
        style={{
         height: "70px",
        }}
       />
      ) : this.state.branchInfo.sesiNABH ? (
       <img
        src={this.state.branchInfo.sesiNABH}
        alt="NABH Certified"
        style={{
         height: "70px",
        }}
       />
      ) : (
       <div>{this.state.branchInfo.hospital_name}</div>
      )}
     </div>
     <div>
      Address:
      <br />
      {this.state.branchInfo.hospital_contact[1]}
      <br />
      {this.state.branchInfo.hospital_contact[2]}
      <br />
      {this.state.branchInfo.hospital_contact[3]}
      {this.state.renderOptions.showGlassRxFooter ? (
       <>
        <br />
        <b>
         Please collect your Glass Prescription from the Spectacle Counter.
        </b>
       </>
      ) : null}
     </div>
    </div>
    <div
     style={{
      display: "flex",
      flexDirection: "row",
      justifyContent: "end",
     }}
    >
     <div
      style={{
       textAlign: "right",
      }}
     >
      {this.state.branchInfo.ClinicPh ? (
       <b
        style={{
         fontSize: "medium",
        }}
       >
        Hospital: {this.state.branchInfo.ClinicPh}
        <br />
       </b>
      ) : null}
      {this.state.branchInfo.EmergencyPh ? (
       <div>
        Office: {this.state.branchInfo.EmergencyPh}
        <br />
       </div>
      ) : null}
      {this.state.branchInfo.affliation === "64fdc342d6098c0c077dee32" ? (
       (this.state.branchInfo.EyeBankPh || this.state.branchInfo.InsurancePh) ? (
        <>
         Reception Number:{" "}
         {[this.state.branchInfo.EyeBankPh, this.state.branchInfo.InsurancePh]
          .filter(Boolean)
          .join(" / ")}
         <br />
        </>
       ) : null
      ) : (
       <>
        {!this.state.renderOptions.suppressEyeBankPh &&
        this.state.branchInfo.EyeBankPh ? (
         <>
          Eye Bank: {this.state.branchInfo.EyeBankPh}
          <br />
         </>
        ) : null}
        {!this.state.renderOptions.suppressInsurancePh &&
        this.state.branchInfo.InsurancePh ? (
         <>
          Insurance: {this.state.branchInfo.InsurancePh}
          <br />
         </>
        ) : null}
       </>
      )}
      {this.state.branchInfo.email ? (
       <>
        {this.state.branchInfo.email}
        <br />
       </>
      ) : null}
      {this.state.branchInfo.website ? (
       <>
        {this.state.branchInfo.website}
        <br />
       </>
      ) : null}
     </div>
     <div
      style={{
       marginLeft: "10px",
      }}
     >
      <QRCode
       size={70}
       value={`https://print.newchart.care/rx2/${this.props.params.visitId}`}
       level="H"
      />
     </div>
    </div>
   </div>,

   <div
    style={{
     display: "flex",
     justifyContent: "center",
    }}
   >
    {this.state.branchInfo.sesiDELT ? (
     <b style={{ color: "red" }}>{this.state.branchInfo.sesiDELT}</b>
    ) : (
     ""
    )}
   </div>,
  ];
 };

 renderBottomHospitalInfoBarSimplified = () => {
  return (
   <>
    <div
     style={{
      display: "flex",
      justifyContent: "center",
      fontSize: "medium",
      marginBottom: "5px",
      borderBottom: "1px solid grey",
     }}
    >
     <b></b>
    </div>
    <div
     style={{
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-start",
     }}
    >
     {/* Logo */}
     <div>
      <img
       alt="Client Logo"
       src={this.state.branchInfo.logoUrl}
       height="80px"
       width="auto"
      />
     </div>

     {/* Hospital Name and Address */}
     <div
      style={{
       marginLeft: "15px",
       marginRight: "15px",
       fontSize: "small",
       textAlign: "left",
       flex: 1,
       display: "flex",
       alignItems: "center",
       height: "80px",
      }}
     >
      <div
       style={{
        textTransform: "uppercase",
        letterSpacing: "0.7mm",
        fontSize: "large",
        textAlign: "left",
       }}
      >
       <b>
        {this.state.branchInfo?.shortcode === "RECC"
         ? "www.renueye.care"
         : this.state.branchInfo.hospital_name}
       </b>
      </div>
     </div>

     {/* Contact Details */}
     <div
      style={{
       textAlign: "left",
       fontSize: "small",
       marginRight: "15px",
       display: "flex",
       alignItems: "center",
       height: "80px",
      }}
     >
      <div>
       {this.state.branchInfo.ClinicPh ? (
        <div>
         <b>Hospital: {this.state.branchInfo.ClinicPh}</b>
         <br />
        </div>
       ) : null}
       {this.state.branchInfo.EmergencyPh ? (
        <div>
         Office: {this.state.branchInfo.EmergencyPh}
         <br />
        </div>
       ) : null}
       {this.state.branchInfo.affliation === "64fdc342d6098c0c077dee32" ? (
        (this.state.branchInfo.EyeBankPh || this.state.branchInfo.InsurancePh) ? (
         <div>
          Reception Number:{" "}
          {[this.state.branchInfo.EyeBankPh, this.state.branchInfo.InsurancePh]
           .filter(Boolean)
           .join(" / ")}
          <br />
         </div>
        ) : null
       ) : (
        <>
         {!this.state.renderOptions.suppressEyeBankPh &&
         this.state.branchInfo.EyeBankPh ? (
          <div>
           Eye Bank: {this.state.branchInfo.EyeBankPh}
           <br />
          </div>
         ) : null}
         {!this.state.renderOptions.suppressInsurancePh &&
         this.state.branchInfo.InsurancePh ? (
          <div>
           Insurance: {this.state.branchInfo.InsurancePh}
           <br />
          </div>
         ) : null}
        </>
       )}
       {this.state.branchInfo.email ? (
        <div>
         {this.state.branchInfo.email}
         <br />
        </div>
       ) : null}
       {this.state.branchInfo.website ? (
        <div>
         {this.state.branchInfo.website}
         <br />
        </div>
       ) : null}
       {this.state.branchInfo.hospital_contact.slice(1).join(" ")}
      </div>
     </div>

     {/* QR Code */}
     <div
      style={{
       display: "flex",
       alignItems: "center",
       height: "80px",
      }}
     >
      <QRCode
       size={70}
       value={`https://print.newchart.care/rx2/${this.props.params.visitId}`}
       level="H"
      />
     </div>
    </div>
   </>
  );
 };

 renderDoc = () => {
  return (
   <div
    style={{
     display: "flex",
     marginBottom: "10px",
     marginLeft: "10px",
     justifyContent: "end",
     alignItems: "center",
     textAlign: "right",
     pageBreakInside: "avoid",
     fontSize: "smaller",
    }}
   >
    <div>
     <br />
     <hr />
     <div style={{ fontSize: "small" }}>
      <b>{this.state.resource.name}</b>
     </div>
     <div>{this.state.resource.qualifications}</div>
     <div>Registration: {this.state.resource.mrNumber}</div>
    </div>
   </div>
  );
 };
 renderPageHeader = () => {
  return (
   <div className="rx21_page_header">{this.renderVisitSummaryTopBar()}</div>
  );
 };
 renderPageFooter = () => {
  return (
   <div
    style={{
     display: "flex",
     flexDirection: "column",
     position: "fixed",
     bottom: 0,
     width: "100%",
     borderTop: "0px",
     height: this.state.renderOptions.footerHeight,
     backgroundColor: "white",
    }}
   >
    {this.state.renderOptions.renderDocPosition === "FOOTER" ? (
     <div style={{ alignSelf: "flex-end", marginRight: "10px" }}>
      {this.renderDoc()}
     </div>
    ) : null}

    {this.state.renderOptions.infoBarStyle === "SIMPLE"
     ? this.renderBottomHospitalInfoBarSimplified()
     : this.renderBottomHospitalInfoBarNew()}
   </div>
  );
 };
 renderContentTable = () => {
  return (
   <table>
    <thead>
     <tr>
      <td>
       <div className="rx21_page_header_space"></div>
      </td>
     </tr>
    </thead>
    <tbody>
     <tr>
      <td>
       <div>
        {this.state.cparams.length > 0 ? (
         <>{this.renderSectionTitle("VISION")}</>
        ) : null}
        <ClinicalVisitParametersPreview
         data={this.state.cparams}
         mode="RX"
         renderOptions={{
          ...this.state.renderOptions,
          showOnlyFAInGlassRx: false, // always show all parameters in Rx
         }}
        />
        {this.renderMainContent()}
        {this.state.renderOptions.renderDocPosition === "MAIN_CONTENT" ? (
         <div style={{ alignSelf: "flex-end", marginRight: "10px" }}>
          {this.renderDoc()}
         </div>
        ) : null}
       </div>
      </td>
     </tr>
    </tbody>
    <tfoot>
     <tr>
      <td>
       <div className="rx21_page_footer_space"></div>
      </td>
     </tr>
    </tfoot>
   </table>
  );
 };
 render() {
  if (this.state.isLoading) {
   return (
    <div
     style={{
      display: "flex",
      width: "100vw",
      height: "100vh",
      alignItems: "center",
      justifyContent: "center",
     }}
    >
     <NonIdealState icon={<Spinner />} title="Loading..." />
    </div>
   );
  }
  if (this.state.isError) {
   return (
    <div
     style={{
      display: "flex",
      width: "100vw",
      height: "100vh",
      alignItems: "center",
      justifyContent: "center",
     }}
    >
     <NonIdealState
      icon="warning-sign"
      title="We ran into an error. If you face this problem multiple times, please contact support."
     />
    </div>
   );
  }
  return (
   <div>
    <div style={{ padding: "3px" }}>
     <style type="text/css" media="print">
      {" @page { size: A4 portrait !important; margin: 5mm !important;"}
     </style>
     {this.renderPageHeader()}
     {this.renderPageFooter()}
     {this.renderContentTable()}
    </div>
   </div>
  );
 }
}

const RxV21_WR = withRouter(RxV21_Dispatch);
export default RxV21_WR;
